import { cn } from '@/lib/utils';

import { getWrapperMaxWidth } from '@/features/utils/utils';

import { MenuGroup, MenuGroupProps } from './MenuGroup';
import { MenuSheetCloseButton } from './MenuSheetCloseButton';

type MenuSheetProps = {
  menu: MenuGroupProps[];
  isOpen: boolean;
  onClose: () => void;
  onLinkClick?: (
    params: { title: string } | { url: string; keepMenuOpen?: boolean }
  ) => void;
};

export function MenuSheet({
  menu,
  isOpen,
  onClose,
  onLinkClick,
}: MenuSheetProps) {
  return (
    <div
      className={cn(
        'headerLg:grid headerLg:grid-rows-[max-content] bg-base-dark-white headerLg:px-10 headerLg:max-h-[calc(100vh-50px)] absolute inset-0 top-full h-max w-full origin-top overflow-hidden',
        'transition-all duration-200 ease-out',
        isOpen ? 'visible' : '!hidden'
      )}
    >
      <section
        className={cn(
          'relative mx-auto h-full w-full',
          getWrapperMaxWidth('mid')
        )}
      >
        <ul className='headerLg:max-h-[calc(100vh-50px)] flex h-full'>
          {menu.map((group, i) => (
            <li
              key={i}
              className={cn(
                group.lists.length === 0 && 'hidden',
                group.type === 'main' && 'headerLg:-ml-3 flex-grow',
                group.type === 'extra' &&
                  'headerLg:basis-[368px] headerLg:max-w-[368px]'
              )}
            >
              <MenuGroup
                type={group.type}
                carousel={group.carousel}
                lists={group.lists}
                onLinkClick={onLinkClick}
              />
            </li>
          ))}
        </ul>
        <MenuSheetCloseButton onClose={onClose} />
      </section>
    </div>
  );
}
